var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pdfok)?_c('div',{staticClass:"pdfok",attrs:{"id":"pdfok"}}):_vm._e(),_c('div',{staticStyle:{"width":"21cm","margin":"0 auto"},attrs:{"id":"printMe"}},[(_vm.dataover)?_c('innerPage',{attrs:{"stuInfo":_vm.formData,"type":1}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }